const Banner = '/assets/serenamar/home/banner.png';
const OriginIcon = '/assets/serenamar/home/origin.svg';
const DestinationIcon = '/assets/serenamar/home/destination.svg';
const pin = '/assets/serenamar/home/destination.svg';
const CalendarIcon = '/assets/serenamar/home/calendar.svg';
const BookingActive = '/assets/serenamar/home/ticket-blue.svg';
const BookingInActive = '/assets/serenamar/home/ticket-white.svg';
const CancelActive = '/assets/serenamar/home/cancel-blue.svg';
const CancelInActive = '/assets/serenamar/home/cancel-white.svg';
const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const HeaderLogo = '/assets/serenamar/home/serena-mar-logo.svg';
const FooterLogo = '/assets/serenamar/home/serenamar-logo-white.svg';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';

// Icons Section
const ist = '/assets/serenamar/icons/seat.svg';
const second = '/assets/serenamar/icons/usb.svg';
const third = '/assets/serenamar/icons/digital-ticket.svg';
const Whatsapp = '/assets/serenamar/icons/whatsapp.svg';
const Email = '/assets/serenamar/icons/email.svg';
const HeadPhone = '/assets/serenamar/icons/headphone.svg';
const PopupIcon = '/assets/serenamar/home/banner-popup.jpg';
const pnr = '/assets/serenamar/home/find-my-pnr.svg';
const close = '/assets/serenamar/icons/close.svg';

const success = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-CheckMark-Orange.svg';
const failure = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Information-Orange.svg';

const tick = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Tick-Orange.svg';
const heartOn = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOn-Orange.svg';
const heartOff = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOff-Orange.svg';
const downArrow = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-DropDown-Orange.svg';
const registrationSuccess = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RightDocument-Orange.svg';
const userIcon = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Login-Orange.svg';
const trips = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyTrips-Orange.svg';
const cards = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyCards-Orange.svg';
const wallet = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const transaction = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-ShareMoney-Orange.svg';
const otp = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RestorePassword-Orange.svg';
const ChangeActive = '/assets/serenamar/home/Changeticketicon_Blue.svg';
const ChangeInActive ='/assets/serenamar/home/Changeticketicon_white.svg';
const operatorPay ='/assets/serenamar/home/Logo-SerenaPay-240x52.png';


const serenamarIcons = [
  { icon: operatorPay, name: 'operatorPay' },

  { icon: ChangeInActive, name: 'CTIA' },
  { icon: ChangeActive, name: 'CTA' },
  { icon: downArrow, name: 'downArrow' },
  { icon: userIcon, name: 'userIcon' },
  { icon: trips, name: 'trips' },
  { icon: cards, name: 'cards' },
  { icon: wallet, name: 'wallet' },
  { icon: transaction, name: 'transaction' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: tick, name: 'tick' },
  { icon: heartOn, name: 'heartOn' },
  { icon: heartOff, name: 'heartOff' },
  { icon: registrationSuccess, name: 'registrationSuccess' },
  { icon: otp, name: 'otp' },

  { icon: HeaderLogo, name: 'headerLogo' },
  { icon: FooterLogo, name: 'footerLogo' },
  { icon: Banner, name: 'Banner' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: OriginIcon, name: 'Origin' },
  { icon: DestinationIcon, name: 'Destination' },
  { icon: pin, name: 'pin' },
  { icon: CalendarIcon, name: 'Calendar' },
  // { icon: SearchIcon, name: 'Search' },
  { icon: BookingInActive, name: 'BIA' },
  { icon: BookingActive, name: 'BA' },
  { icon: CancelInActive, name: 'CIA' },
  { icon: CancelActive, name: 'CA' },
  { icon: animation, name: 'animation' },
  { icon: checkboxIcon, name: 'Checkbox' },
  { icon: Whatsapp, name: 'Whatsapp' },
  { icon: Email, name: 'Email' },
  { icon: HeadPhone, name: 'Headphone' },

  // Icons Section
  { icon: ist, name: 'ist' },
  { icon: second, name: 'second' },
  { icon: third, name: 'third' },
  { icon: PopupIcon, name: 'Popup' },
  { icon: pnr, name: 'pnr' },
  { icon: close, name: 'close' },
];

export default serenamarIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/serenamarIcons.js